import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSearchBarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseShortcutsModule } from '../../../fuse/components/shortcuts/shortcuts.module';

import { ToolbarComponent } from 'app/modules/layout/components/toolbar/toolbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { AngularMaterialModule } from 'app/angular-material.module';

@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports     : [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        MatBadgeModule,
        AngularMaterialModule
    ],
    exports     : [
        ToolbarComponent,
        MatBadgeModule
    ]
})
export class ToolbarModule
{
}
